import React, { useState } from 'react'
import { Pencil } from 'lib/lucide'

import { ERRORS } from 'consts'
import { useApi } from 'hooks'
import { snackbar } from 'components'

import { getMemberships } from './api'
import { DefaultTable } from '../components'
import { GetMembershipsResponse, Membership } from './types'
import { UpdateMembershipDialog } from './components'

const columns = [
  { title: 'ID', field: 'id' },
  { title: 'Título', field: 'title' },
  { title: 'Puntos por nivel', field: 'amountVisits' },
  { title: 'Nivel', field: 'level' },
]

const getMembershipsResponseGetter = (responseData: GetMembershipsResponse) =>
  responseData?.memberships ?? []

const Memberships: React.FC = () => {
  const [{ data: membships, isLoading }, , setMemberships] = useApi<
    GetMembershipsResponse,
    Membership[]
  >(getMemberships, getMembershipsResponseGetter, {
    baseData: [],
    onError: () => snackbar.show(ERRORS.GENERIC_ERROR_MESSAGE),
  })

  const [isUpdateDialogOpen, setIsUpdateDialogOpen] = useState(false)
  const [membershipToUpdate, setMembershipToUpdate] = useState<Membership | null>(null)

  const closeUpdateDialog = () => {
    setIsUpdateDialogOpen(false)
    setMembershipToUpdate(null)
  }

  const onUpdateDone = (newMembership: Membership) => {
    setMemberships(
      membships.map(membership => {
        if (membership.id === newMembership.id) return newMembership
        return membership
      }),
    )
    closeUpdateDialog()
  }

  const actions = [
    {
      icon: () => <Pencil size={20} />,
      tooltip: 'Editar nivel',
      isFreeAction: false,
      onClick: (_: React.SyntheticEvent, membresia: Membership | Membership[]) => {
        setMembershipToUpdate(membresia as Membership)
        setIsUpdateDialogOpen(true)
      },
    },
  ]

  return (
    <>
      <DefaultTable
        title="Niveles"
        columns={columns}
        data={membships}
        isLoading={isLoading}
        actions={actions}
      />
      {isUpdateDialogOpen && membershipToUpdate && (
        <UpdateMembershipDialog
          membership={membershipToUpdate}
          handleClose={closeUpdateDialog}
          onDone={onUpdateDone}
          amountVisitsUsed={membships.map(membership => Number(membership.amountVisits))}
        />
      )}
    </>
  )
}

export { Memberships }
